module.exports = __webpack_public_path__ + "assets/img/goods1.d771a2d8.svg";